<p-button label="Obriši sliku" icon="pi pi-trash" (click)="removeImage()" />